__turbopack_context__.v({
  "className": "fraunces_1a88a32e-module__jeIe5a__className",
});
